/* eslint-disable security/detect-object-injection */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import '@jutro/legacy/address';
import { ModalNextEmitter, useModal } from '@jutro/components';
import '@jutro/legacy/dataview';
import { useBreakpoint } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { routeConfirmationModal, DropdownMenuLink, Link } from '@jutro/router';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { withMaintenancePage } from '@xengage/gw-portals-maintenance-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { withAuthenticationProvider } from 'ent-capability-digital-auth-react';
import { AccurateBreakpointPropagation } from '@xengage/gw-jutro-adapters-react';
import vmTranslator, {
    messages as commonMessages,
} from '@xengage/gw-platform-translations';
import { TWIAResourcesService } from 'twia-capability-constants';
import { filterCapabilityRoutes } from '@xengage/gw-portals-config-js';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';
import { ViewModelServiceFactory } from '@xengage/gw-portals-viewmodel-js';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import htmlParser from 'html-react-parser';
import appConfig from 'app-config';
import {
    AccountBillingDetailsService,
    BillingService,
} from 'gw-capability-billing';
// import {
// billingAdditionalComponents,
// billingComponentMap,
// BillingSummaryPage,
// MakePaymentPage
// } from 'gw-capability-billing-react';
import {
    billingAdditionalComponents,
    billingComponentMap,
    MakePaymentPage,
    ManagePaymentMethodsPage,
    BillingSummaryPage
} from 'ent-capability-billing-react';
import { ClaimService } from 'gw-capability-claim';
import {
    ClaimDetails,
    ClaimList,
    PolicyLevelCoverages,
} from 'gw-capability-claim-react';
import { ClaimDocumentService } from 'gw-capability-claimdocument';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { AdditionalEnrollment } from 'gw-capability-enrollment-react';
import FaqPage from 'gw-capability-faq-react';
import { FNOLService } from 'gw-capability-fnol';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import BaseFNOLWizard, {
    ClaimsConfirmationPage,
} from 'twia-capability-fnol-common-react';
import FNOLCPWizard from 'twia-capability-fnol-cp-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import FNOLHOWizard from 'twia-capability-fnol-ho-react';
import FNOLHOTFPAWizard from 'tfpa-capability-fnol-ho-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
// TWIA
import { TWIAResidentialWizard } from 'twia-capability-quoteandbind-residential-react';
import { TWIACommercialWizard } from 'twia-capability-quoteandbind-cp-react';
import { TWIAWizardTemplate } from 'twia-portals-wizard-components-ui';
import { TFPAWizardTemplate } from 'tfpa-portals-wizard-components-ui';
import {
    personalizedOfferComponentMap,
    personalizedOfferComponents,
} from 'gw-capability-personalizedoffers-react';
import { PolicyService } from 'gw-capability-policy';
import { GatewayFNOLService } from 'twia-capability-gateway-fnol';
import { PolicyholderRegistrationPage } from 'ent-capability-policyholderregistration-react';
import {
    OfferDetails,
    SubmissionSuccessfulPage
} from 'twia-capability-policy-react';
import { PolicyDetails } from 'gw-capability-policy-react';
import { EndorsementService } from 'gw-capability-policychange';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import {
    policyJobComponentMap,
    policyJobComponents,
} from 'gw-capability-policyjob-react';
import { checkMaintenanceMode }  from 'gw-maintenance-js';
import { ProducerInfoService } from 'gw-capability-profileinfo';
import { UsersProfile } from 'gw-capability-profileinfo-react';
import {
    VehicleInfoLookupComponentMap,
    VehicleInfoLookupComponents,
} from 'gw-capability-vehicleinfo-react';
import {
    ImageComponent,
    platformComponentMap,
    platformComponents,
} from 'gw-components-platform-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import _, { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, BrowserRouter as Router } from 'react-router-dom';
import { Autologout } from 'ent-capability-autologout-react';
import { LogoutPage } from 'ent-capability-logout-react';
import { getConfigValue } from '@jutro/config';
import { AppFloorPlan } from '@jutro/legacy/floorplan';
import StandardAddressValidationUtil from 'twia-capability-quoteandbind-residential-react/util/StandardAddressValidationUtil';
import ManageClaims from '../components/ManageClaims/ManageClaims';
import Disclaimer from '../components/Disclaimer/Disclaimer';
import LandingPage from '../pages/LandingPage/LandingPage';
import messages from './App.messages';
import appRoutes from './App.routes.metadata.json5';
import tfpaAppRoutes from './TFPAApp.routes.metadata.json5';
import { AccountService } from 'gw-capability-gateway-policy';
// Imported First to allow Jutro styles to be overridden
import './App.scss';


const { capabilitiesConfig, env, applicationDetails } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    fnolhotfpawizard: FNOLHOTFPAWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    offerdetailspage: OfferDetails,
    policydetailspage: PolicyDetails,
    submissionsuccessfulpage: SubmissionSuccessfulPage,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    managepaymentmethodspage: ManagePaymentMethodsPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    twiaresidentialwizard: TWIAResidentialWizard,
    twiacommercialwizard: TWIACommercialWizard,
    policyholderregistrationpage: PolicyholderRegistrationPage,
    logoutpage: LogoutPage,
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        WizardPageTemplateWithTitle: {
            component: 'WizardPageTemplateWithTitle',
        },
        TWIAWizardTemplate: {
            component: 'TWIAWizardTemplate',
        },
        TFPAWizardTemplate: {
            component: 'TFPAWizardTemplate',
        },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
        ManageClaims: {
            component: 'ManageClaims'
        },
        Disclaimer: {
            component: 'Disclaimer'
        }
    },
    {
        ...platformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        WizardPageTemplateWithTitle,
        TWIAWizardTemplate,
        TFPAWizardTemplate,
        img: ImageComponent,
        ManageClaims,
        Disclaimer
    }
);

const routesWithTitle = filterCapabilityRoutes(
    capabilitiesConfig,
    appRoutes.routes
);

const tfpaRoutesWithTitle = filterCapabilityRoutes(
    capabilitiesConfig,
    tfpaAppRoutes.routes
);

const modalEmitter = new ModalNextEmitter();

const getUserAuthData = async (authData) => {
    if (authData?.authHeader) {
        const contactSummaries = await ProducerInfoService.getContactSummaries(authData.authHeader);

        if (contactSummaries.length > 0) {
            const { associationName_TWIA } = contactSummaries[0]

            authData.authUserData = { associationName_TWIA }

            const PUBLIC_ID_FIELD = 'publicID';

            const allProducerSummariesAreEqual = contactSummaries.every(summary => summary[PUBLIC_ID_FIELD] === contactSummaries[0][PUBLIC_ID_FIELD]);
            
            if (allProducerSummariesAreEqual) {
                authData.producerData = contactSummaries[0];
            }

        } else {
            authData.noCurrentAuthorizations_TWIA = true;
        }
    }

    return authData
};

function App() {
    const { showAlert } = useModal();

    const auth = useAuthentication();
    const translator = useTranslator();
    const [viewModelService, setViewModelService] = useState(undefined);
    const location = useLocation();
    const [banner, setBanner] = useState('');
    const { breakpoint } = useBreakpoint({});

    const getAvatarLinks = useCallback(
        () => {
            // US29415: PE/CE -Enable optional MFA (multi-factor authentication) for Agents and policyholders
            const accountSecurityBaseUrl = getConfigValue('ACCOUNT_SECURITY_URL', appConfig.accountSecurityUrl);
            const jutroAuthRedirectBase = getConfigValue('JUTRO_AUTH_REDIRECT_BASE', appConfig.authentication.servers.okta.JUTRO_AUTH_REDIRECT_BASE);
            const accountSecurityUrl = accountSecurityBaseUrl + jutroAuthRedirectBase;
            const urlTWIA = 'https://www.twia.org/support';
            const urlTFPA = 'https://www.texasfairplan.org/support/ ';
            const noAuths = _.get(auth, 'authUserData.noCurrentAuthorizations_TWIA');
            let helpURL = '';

            if (auth && auth.authUserData) {
                const { authUserData: { associationName_TWIA } } = auth;

                if (associationName_TWIA === 'twia') {
                    helpURL = urlTWIA;
                }
                else if (associationName_TWIA === 'tfpa') {
                    helpURL  = urlTFPA;
                }
            }

            return [
                (!noAuths && <DropdownMenuLink to="/userprofile">
                    {translator(messages.account)}
                </DropdownMenuLink>),
                <DropdownMenuLink href={accountSecurityUrl}>
                    {translator(messages.addAccountSecurity)}
                </DropdownMenuLink>,
                (!noAuths && (breakpoint === 'phone' || breakpoint === 'phoneWide')) && (<DropdownMenuLink target="_blank" href={helpURL}>
                    {translator(messages.help)}
                </DropdownMenuLink>)
            ];
        },
        [auth, breakpoint, translator]
    );

    
    const getLogoSrc = useCallback(() => {
        let logoName = '';       

        if (auth && auth.authUserData) {
            const { authUserData: { associationName_TWIA } } = auth;

            if (associationName_TWIA === 'twia') {
                if (breakpoint === 'phone' || breakpoint === 'phoneWide' || breakpoint === 'tablet') {
                    logoName = applicationDetails.applicationLogoTWIAMobile;
                } else {
                    logoName = applicationDetails.applicationLogoTWIA;
                }                
            }
            else if (associationName_TWIA === 'tfpa') {
                if (breakpoint === 'phone' || breakpoint === 'phoneWide' || breakpoint === 'tablet') {
                    logoName = applicationDetails.applicationLogoTFPAMobile;
                } else {
                    logoName = applicationDetails.applicationLogoTFPA;
                } 
                
            }
        }

        if (_.get(auth, 'authUserData.noCurrentAuthorizations_TWIA')) {
            logoName = applicationDetails.applicationLogoDual;
        }

        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');

        return `${prefix}/${logoName}`;
    }, [auth, breakpoint]);

    const showNavBar = useMemo(() => {
        // US25426 - Don't show navbar for signup
        const result = !location.pathname.includes('signup');

        return result;
    }, [location.pathname]);

    const filterRoutes = useMemo(() =>
        /**
         * US25426: CE - New User Registration -TWIA
         * only return signup route for signup requests
         */
        routesWithTitle.filter((route) => {
            if (location.pathname.includes('signup')) {
                return route.path.includes('signup');
            }

            return true;
        })
        , [location]);

    const filterTFPARoutes = useMemo(() =>
        /**
         * US25426: CE - New User Registration -TWIA
         * only return signup route for signup requests
         */
        tfpaRoutesWithTitle.filter((route) => {
            const noAuth = auth?.authUserData?.noCurrentAuthorizations_TWIA;
            
            if (location.pathname.includes('signup')) {
                return route.path.includes('signup');
            }

            return noAuth !== true || !route.path.includes('/additional-enrollment');
        })
        , [auth, location]);

    const navigateToTWIASupportPage = useCallback(() => {
        const urlTWIA = 'https://www.twia.org/support';
        const urlTFPA = 'https://www.texasfairplan.org/support/ ';

        if (auth && auth.authUserData) {
            const { authUserData: { associationName_TWIA } } = auth;

            if (associationName_TWIA === 'twia') {
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                window.open(urlTWIA, '_blank');
            }
            else if (associationName_TWIA === 'tfpa') {
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                window.open(urlTFPA, '_blank');
            }
        }
    }, [auth]);

    const getRoutes = () => {
        if (auth && auth.authUserData) {
            return (auth.authUserData?.noCurrentAuthorizations_TWIA
                || auth.authUserData?.associationName_TWIA === 'tfpa') ? filterTFPARoutes : filterRoutes
        }
        return filterRoutes
    }

    const floorPlansConfig = useMemo(
        () => [
            {
                scrollContent: false,
                showFooter: false,
                showHeader: showNavBar,
                routes: getRoutes(),
                header: {
                    avatarChildren: getAvatarLinks(),
                    avatarProps: {
                        username: _.get(auth, 'userInfo.name'),
                        title: _.get(auth, 'authUserData.displayName'),
                        subtitle: _.capitalize(
                            _.get(auth, 'authUserData.userType')
                        )
                    },
                    className: 'appHeader',
                    logoSrc: getLogoSrc(),
                    showAppSwitcher: false,
                    showNotifications: false,
                    // 2025-02-01 - Debra Frum - US25432 - CE - Policy Holds
                    // Display information banner
                    renderCustomComponent: () => (
                        <React.Fragment>
                            {
                                _.get(auth, 'authUserData.noCurrentAuthorizations_TWIA') ?
                                <span/> : 
                                <div className="customComponentDiv">
                                    <Link
                                        className="helpLinkMargin"
                                        onClick={() => navigateToTWIASupportPage()}>
                                        {translator(messages.help)}
                                    </Link>
                                </div>
                            }
                            {
                                banner !== "" ? <div className="portalBannerContainer">
                                    <div className="portalBannerContent">
                                        <i className="fa fa-exclamation-triangle bannerIcon" />
                                        <span>
                                            {htmlParser(banner)}
                                        </span>

                                    </div>
                                </div> : <span />
                            }
                        </React.Fragment>
                    )
                }
            },
        ],
        [auth, banner, getAvatarLinks, getLogoSrc, getRoutes, navigateToTWIASupportPage, showNavBar, translator]
    );

    useEffect(() => {
        const translatorFn = vmTranslator(translator);

        import(
            /* webpackChunkName: "product-metadata" */

            'product-metadata'
        ).then(productMetadata => {
            if (!productMetadata || _.isEmpty(productMetadata.default)) {
                throw new Error(translator(messages.errorMetadataMessage));
            }

            const { default: result } = productMetadata;

            setViewModelService(
                ViewModelServiceFactory.getViewModelService(
                    result,
                    translatorFn
                )
            );

            StandardAddressValidationUtil.setProductMetadata(result);
        });

        const cfg = appConfig.autoLogout;
        const idleTimeMinutes = getConfigValue('IDLE_TIME_MINUTES', cfg.idleMinutes);
        const logoutTimeMinutes = getConfigValue('LOGOUT_TIME_MINUTES', cfg.logoutMinutes);

        if (!_.isEmpty(auth)) {
            Autologout.enableAutoLogout(showAlert, auth.logout, idleTimeMinutes, logoutTimeMinutes);

            // 2025-02-01 - Debra Frum - US25432 - CE - Policy Holds
            // Retrieve information banner
            const { authUserData: { associationName_TWIA }, authHeader } = auth;
            const association = associationName_TWIA === 'twia' ? 'twiapolicyholder' : '';
 
            if (!isEmpty(association)) {
                TWIAResourcesService.getPortalBannerTWIA(association, authHeader).then((result) => {
                    if (!isEmpty(result)) {
                        setBanner(`${result} ${translator(messages.bannerContactAgent)}`)
                    }
                })
            }
        }

    }, [auth, showAlert, translator]);

    useEffect(() => {
        // eslint-disable-next-line no-secrets/no-secrets
        /**
         * US30038: Fix Abandoned CE Registrations
         * Update PC Acccount RegisteredCEUsername_TWIA on login
         * instead of registration which can be abandoned
         * which led to data integrity issues.
         */
        const updateAccountCEUsername = async () => {
            if (!_.isEmpty(auth) && !_.isEmpty(auth.userInfo)) {
                const { authHeader } = auth;
                const authorities = _.get(auth, 'userInfo.grantedAuthorities');
                const username = _.get(auth, 'userInfo.preferred_username')

                if(authorities && username){
                    const accountNumbers = _.chain(authorities).filter((authority)=>(authority.includes("account"))).map((authority) => authority.replace("guidewire.edge.account.","").replace(".all",""))
    
                    if(accountNumbers){
                       await AccountService.updateAccountCEUsername_TWIA(username.replace(/twia-\w*prod-/,"").replace(/@twiaportal\.org/,""),accountNumbers, authHeader).catch(err => {
                            const errorCode = _.get(err, 'data.appErrorCode');
                            
                            // eslint-disable-next-line no-console
                            console.error(`errorCode:${errorCode}`);
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.warn(`updateAccountCEUsername() accountNumbers:'${accountNumbers}' are not applicable`);
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.warn(`updateAccountCEUsername() authorities:'${authorities}' are empty`);
                } 
            } else {
                // eslint-disable-next-line no-console
                console.warn('updateAccountCEUsername() auth is empty.  skipping');
            }           
        }

        updateAccountCEUsername();

    }, [auth]);

    const handleError = useCallback(
        () =>
            showAlert({
                title: messages.error,
                message: messages.errorMessage,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok,
            }).catch(_.noop),
        [showAlert]
    );

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService,
                    PolicyService,
                    EndorsementService,
                    AvailabilityService,
                    FNOLService,
                    GatewayFNOLService,
                    ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService,
                    EnrollmentService,
                    ContactService: ProducerInfoService,
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                        <Router
                            basename="/account-management"
                            getUserConfirmation={(message, callback) =>
                                routeConfirmationModal(
                                    message,
                                    callback,
                                    modalEmitter
                                )
                            }
                        >
                            <AppFloorPlan
                                componentMap={componentMap}
                                floorPlans={floorPlansConfig}
                            />
                        </Router>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default (withMaintenancePage({ appConfig, checkMaintenanceMode}))(
    (withAuthenticationProvider({
        onAuthDataCreation: getUserAuthData,
        unsecuredRoutes: [/.*\/signup/, /.*\/signup-tfpa/,/.*\/logout/]
        })(App))
)
